module.exports = __webpack_public_path__ + "img/logistics_second.61c98805.png";